import { type UploadFile } from "antd"
import { type Dayjs } from "dayjs"

/**
 * Action types
 */
export enum OneFleetDevolucaoFormsTypes {
  "SET_DATA" = "@onefleetdevolucao/SET_DATA",
  "CLEAR_DATA" = "@onefleetdevolucao/CLEAR_DATA",

  "SEARCH_PLATE_CLEAR" = "@onefleetdevolucao/SEARCH_PLATE_CLEAR",
  "SEARCH_PLATE_REQUEST" = "@onefleetdevolucao/SEARCH_PLATE_REQUEST",
  "SEARCH_PLATE_SUCCESS" = "@onefleetdevolucao/SEARCH_PLATE_SUCCESS",
  "SEARCH_PLATE_FAILURE" = "@onefleetdevolucao/SEARCH_PLATE_FAILURE",

  "FINAL_PDF" = "@onefleetdevolucao/FINAL_PDF",
}

export type CountryPhoneCode = { code: string, country: string }

/**
 * Data types
 */
export interface OneFleetDevolucaoForm {
  formId: string
  terms?: boolean

  client: {
    name: string
    cpf: string
    email: string
    phone: string
    phoneCountryCode: CountryPhoneCode
    company: string
  }

  consultant: {
    name: string
    dealer: string
    cityAndState: string
    email: string
    phone: string
    phoneCountryCode: CountryPhoneCode
  }

  car: {
    returnDate: Dayjs
    licensePlate: string
    model: string
    carKm?: number
    hasDamageOrMissingItems: boolean
  }

  damagedOrMissingItems: {
    carProblemDescription: string
    accessoriesStatus?: Record<string, number>
    images?: Record<string, UploadFile[]>
  }

  images: {
    licensePlateFileList: UploadFile[]
    odometerFileList: UploadFile[]
    carFrontFileList: UploadFile[]
    carRightFileList: UploadFile[]
    carBackFileList: UploadFile[]
    carLeftFileList: UploadFile[]
  }

  signatures: {
    clientPicture: UploadFile
    clientCNH: UploadFile
    clientSignatureDots: SignaturePad.Point[][]
    clientSignatureImage: string

    consultantSignatureDots: SignaturePad.Point[][]
    consultantSignatureImage: string
  }
}

export interface OneFleetDevolucaoPlateInfo {
  data?: {
    company?: string
    model?: string
    carKm?: number
    dealer?: string
  }
  error?: boolean
  message?: string
  loading?: boolean
}

/**
 * State type
 */
export interface OneFleetDevolucaoFormsState {
  readonly data: OneFleetDevolucaoForm
  readonly accessories: Array<{ code: number, name: string }>
  readonly accessoryStatus: Array<{ code: number, name: string } & ({ isAProblem: true, demandImage: boolean } | { isAProblem: false, demandImage?: false })>
  readonly plateInfo?: OneFleetDevolucaoPlateInfo
}
